import { resolveNumberEnvVar, resolveStringEnvVar } from './env.utils';

const buildTimeEnv = {
  // Node-managed variables.
} as const;

const runtimeEnv = {
  VITE_AUTH_AUTHORITY: resolveStringEnvVar(
    'VITE_AUTH_AUTHORITY',
    process.env.VITE_AUTH_AUTHORITY,
    ''
  ),
  VITE_AUTH_CLIENTID: resolveStringEnvVar('VITE_AUTH_CLIENTID', process.env.VITE_AUTH_CLIENTID, ''),
  VITE_AUTH_RESPONSE_TYPE: resolveStringEnvVar(
    'VITE_AUTH_RESPONSE_TYPE',
    process.env.VITE_AUTH_RESPONSE_TYPE,
    ''
  ),
  VITE_AUTH_SCOPE: resolveStringEnvVar('VITE_AUTH_SCOPE', process.env.VITE_AUTH_SCOPE, ''),
  VITE_AUTH_REDIRECT_URI: resolveStringEnvVar(
    'VITE_AUTH_REDIRECT_URI',
    process.env.VITE_AUTH_REDIRECT_URI,
    ''
  ),
  VITE_AUTH_POST_LOGOUT_REDIRECT_URL: resolveStringEnvVar(
    'VITE_AUTH_POST_LOGOUT_REDIRECT_URL',
    process.env.VITE_AUTH_POST_LOGOUT_REDIRECT_URL,
    ''
  ),
  VITE_API_HOST: resolveStringEnvVar('VITE_API_HOST', process.env.VITE_API_HOST, ''),
  VITE_API_TIMEOUT: resolveNumberEnvVar('VITE_API_TIMEOUT', process.env.VITE_API_TIMEOUT, 10000),
  VITE_LANGUAGE_API: resolveStringEnvVar(
    'VITE_LANGUAGE_API',
    process.env.VITE_LANGUAGE_API,
    ''
  ),
  VITE_ONE_TRUST_ID: resolveStringEnvVar('VITE_ONE_TRUST_ID', process.env.VITE_ONE_TRUST_ID, ''),
  // App config
  VITE_INACTIVITY_TIMEOUT: resolveNumberEnvVar(
    'VITE_INACTIVITY_TIMEOUT',
    process.env.VITE_INACTIVITY_TIMEOUT,
    1000
  ),
};

export const env = {
  ...buildTimeEnv,
  ...runtimeEnv,
} as const;
